import type { ChecklistItemStatus } from '../../../checklist/types/ChecklistItemStatus.enum';

/** Highcharts' global series colors, and entries 7-10 are provisional. */
export const WIDGET_PALETTE: readonly string[] = [
  '#10667F', // napa-wake-darker (wake-600)
  '#A17DA1', // napa-acropora-darker (acropora-600)
  '#4DAB9C', // napa-aqua-darker (aqua-600)
  '#2596B8', // napa-wake-lighter (wake-400)
  '#D4ACD4', // napa-acropora-lighter (acropora-400)
  '#61C8B8', // napa-aqua-default (aqua-500)
  '#0A4152', // provisional wake-800
  '#6C516C', // provisional acropora-800
  '#36776D', // provisional aqua-800
  '#69C7E3', // provisional wake-200
];

/** A task status keeps its color whichever other statuses a chart shows, which positional palette colors would not. */
export const ITEM_STATUS_COLORS: Readonly<Record<ChecklistItemStatus, string>> =
  {
    Completed: WIDGET_PALETTE[0],
    Failed: WIDGET_PALETTE[1],
    NotApplicable: WIDGET_PALETTE[2],
    Unchecked: WIDGET_PALETTE[3],
  };
